import Image from 'next/image';

const MidleSection = () => {
  return (
    <>
      <section id="rewarded" className="px-[5%] lg:px-[18%] py-16 md:mt-20">
        <div className="flex flex-col-reverse md:flex-row justify-center md:justify-between items-center md:items-start xl:pr-[5%]">
          <div className="flex-none md:min-w-[60%] md:w-[60%] lg:w-[75%] md:pr-10">
            <div className="md:flex justify-center md:justify-start gpa-2 md:items-start">
              <h2 className="text-lg md:text-[24px] lg:text-[28px] font-semibold text-center md:text-start pt-5 md:pt-0">
                Turn Your Passion into Rewards:
              </h2>
              <span className="ml-5 ">
                <Image
                  src="https://res.cloudinary.com/see-sight-tours/image/upload/v1690184063/Remaining%20images/Partners/material-symbols_rewarded-ads-outline_rtz5ej.svg"
                  width={30}
                  height={30}
                  alt="https://res.cloudinary.com/see-sight-tours/image/upload/v1689853819/Remaining%20images/Partners/material-symbols_rewarded-ads-outline_v7u6vv.svg"
                  className="hidden md:block"
                />
              </span>
            </div>

            <p className="md:mt-5 text-justify md:text-start text-sm md:text-base lg:text-lg font-normal px-6 md:px-0 lg:leading-10 leading-6 ">
              Experience the See Sight Tours affiliate partner program! Inspire
              your audience to explore the wonders of travel with See Sight
              Tours. Earn an attractive 12% commission on each successful
              booking as our partner. Let&apos;s join hands to share the
              excitement of discovery and earn together. Your love for travel,
              combined with our collaboration, makes for an amazing journey.
            </p>
          </div>
          <div className="flex-none min-w-[20%] relative w-[200px] h-[200px]  md:w-[270px]  md:h-[270px] aspect-square ">
            <Image
              src="https://res.cloudinary.com/see-sight-tours/image/upload/v1695022341/SST%20Website%20%28Compressed%20Images%29/partner_page/women_ertycp.png"
              fill
              quality={100}
              alt="rewarded"
              className="rounded-2xl object-cover shadow-tourExpImgBox "
            />
          </div>
        </div>
      </section>
      <section
        id="attractions"
        className="px-[5%] lg:px-[18%] py-16 bg-[#DFEEEE]"
      >
        <div className="flex flex-col items-center md:items-start md:flex-row justify-between">
          <div className="flex-none justify-center md:justify-start pt-[6%]  relative w-[200px] h-[200px]  md:w-[270px]  md:h-[270px] aspect-square">
            <Image
              src="https://res.cloudinary.com/see-sight-tours/image/upload/v1695022341/SST%20Website%20%28Compressed%20Images%29/partner_page/buiilding_e3qhjr.png"
              fill
              quality={100}
              alt="rewarded"
              className="rounded-2xl object-cover shadow-tourExpImgBox"
            />
          </div>
          <div className="  px-6 sm:px-10 relative md:min-w-[60%] md:w-[60%] lg:w-[75%]  ">
            <div className="md:flex justify-center md:justify-start gpa-2 items-start">
              <h2 className="text-lg md:text-[24px] lg:text-[28px] font-semibold text-center md:text-start pt-5 md:pt-0">
                Showcase Our Attractions
              </h2>
              <span className="ml-5 ">
                <Image
                  src="https://res.cloudinary.com/see-sight-tours/image/upload/v1690184063/Remaining%20images/Partners/mdi_location-path_ttmpfh.svg"
                  width={30}
                  height={30}
                  alt="https://res.cloudinary.com/see-sight-tours/image/upload/v1690184063/Remaining%20images/Partners/mdi_location-path_ttmpfh.svg"
                  className="hidden md:block"
                />
              </span>
            </div>
            <p className="md:mt-5 text-sm md:text-base lg:text-lg font-normal text-justify md:text-start lg:leading-10 leading-6  ">
              Our depth of inventory unlocks the best possibilities for each
              traveler’s unique needs. See Sight Tours is operating in over 23
              cities across US and Canada. We are going exponentially which
              means your audience is getting more and more options to enjoy with
              expert guides and custom-made plans, these tours offer you a
              chance to have an amazing adventure that you&apos;ll always
              remember.
            </p>
          </div>
        </div>
      </section>
      <section id="small-group" className="px-[5%] lg:px-[18%] py-16">
        <div className="flex flex-col-reverse md:flex-row justify-between items-center md:items-start  xl:pr-[5%]">
          <div className="flex-none md:min-w-[60%] md:w-[60%] lg:w-[75%] md:pr-10">
            <div className="md:flex justify-center md:justify-start gpa-2 items-center">
              <h2 className="className='text-lg md:text-[24px] lg:text-[28px] font-semibold text-center md:text-start pt-5 md:pt-0">
                Fam Tour:
              </h2>
              <span className="ml-5 ">
                <Image
                  src="https://res.cloudinary.com/see-sight-tours/image/upload/v1690184063/Remaining%20images/Partners/heroicons-outline_user-group_of6xrt.svg"
                  width={30}
                  height={30}
                  alt="https://res.cloudinary.com/see-sight-tours/image/upload/v1689853819/Remaining%20images/Partners/heroicons-outline_user-group_h1i8xw.svg"
                  className="hidden md:block"
                />
              </span>
            </div>

            <p className="md:mt-5 text-sm md:text-base lg:text-lg font-normal text-justify md:text-start px-6 md:px-0 lg:leading-10 leading-6">
              Our small group tours are designed for unforgettable experiences,
              led by passionate guides. With 6000+ reviews, our customers love
              the magic we bring to each tour. Join us in sharing the joy of
              exploration and becoming a part of our journey at See Sight Tours!
              Plus, we offer exclusive fam tours to our affiliate partners,
              adding an extra layer of excitement to our collaboration.
            </p>
          </div>
          <div className="flex-none pt-[6%]  relative w-[200px] h-[200px]  md:w-[270px]  md:h-[270px] aspect-square">
            <Image
              src="https://res.cloudinary.com/see-sight-tours/image/upload/v1695022340/SST%20Website%20%28Compressed%20Images%29/partner_page/Fleet_auixv8.png"
              fill
              quality={100}
              alt="rewarded"
              className="rounded-2xl object-cover shadow-tourExpImgBox "
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default MidleSection;
